import { CartaoPeriodoPadrao } from '../shared/enums/cartao-periodo-padrao.enum';

export class Card {
    standardValue: number;
    standardPeriodId: CartaoPeriodoPadrao;
    standardPeriod: string;
    expirated: boolean;
    suspended: boolean;
    isEditable: boolean;
    productGuid: string;
    productDescription: string;
    productColor: string;
    productIcon: string;
    productCategory: number;
    public cardId: number;
    public assignorContractId: number;
    public collaboratorId: number;
    public expirationDate: Date;
    public referenceValue: number;
    public regularityId: CartaoPeriodoPadrao;
    public regularityDescription: string;
    public mode: string;
    public cvv: number;
    public createdDate: Date;
    public updateDate: Date;
    public active: boolean;
    constructor(
    ) { }
}
